import styles from './PageProduct.module.css';
import Page from './Page.js';
import Theme from './Theme.js';
import useSearchParamOrDefaultProps from '../hooks/useSearchParamOrDefaultProps.js';
import ProductsContext from '../contexts/ProductsContext.js';
import useProducts from '../hooks/useProducts.js';
import hasProductsWithSpecialOfferRatePlan from '../utils/hasProductsWithSpecialOfferRatePlan.js';
import PageProductHeader from './PageProductHeader.js';
import PageProductHero from './PageProductHero.js';
import PageProductSignInLink from './PageProductSignInLink.js';
import PageProductComparison from './PageProductComparison.js';
import PageProductPartners from './PageProductPartners.js';
import PageProductValueSummaries from './PageProductValueSummaries.js';
import PageProductPortfolioValueSummaries from './PageProductPortfolioValueSummaries.js';
import PageProductValuePropositions from './PageProductValuePropositions.js';
import PageProductFooter from './PageProductFooter.js';
import PageProductIntroMobileSubcopy from './PageProductIntroMobileSubcopy.js';

const PageMarketing = () => {
  const {
    offerGroup,
    theme,
    showProductComparisonSection,
    showProductValuePropositionsSection,
    showProductPartnersSection,
    showPortfolioValuePropositionsSection,
    showPageProductStockScreenerGate,
    productSku,

    // !IMPORTANT: Property name and value are used to determine the max-height of the iframe during integration
    // during full page takeover max-height is unset. When top page header and footer are present
    // max-height is set to 100vh to delegate scrolling to the iframe and enable sticky header (native sticky requires
    // scroll). After exploring multiple options (e.g., intersection observer, post messages from top page),
    // believe this is the simplest (CSS is declarative) and most performant way forward (enables native
    // sticky header behavior). Property is used in src/integration.css see that file for additional explaination.
    hideHeader,
  } = useSearchParamOrDefaultProps();

  const { loading, error, products } = useProducts({
    offerGroup,
    mock: true,
    // mockType: 'specialOffer',
  });

  if (!products) {
    // TODO: likely render everything except rate data and have a loading skeleton
    // https://www.npmjs.com/package/react-loading-skeleton
    return null;
  }

  const isSpecialOffer = hasProductsWithSpecialOfferRatePlan(products);
  return (
    <Theme>
      <Page>
        <ProductsContext.Provider value={products}>
          <div className={`${theme} ${styles.PageProduct}`}>
            {hideHeader !== 'true' && <PageProductHeader />}

            <div className={styles.PageProductSectionsWrapper}>
              <PageProductHero />
              {showPortfolioValuePropositionsSection === 'true' ? (
                <PageProductPortfolioValueSummaries />
              ) : (
                <>
                  <PageProductSignInLink isMobile={true} />
                  {showPageProductStockScreenerGate === 'true' && (
                    <PageProductIntroMobileSubcopy />
                  )}
                </>
              )}

              <PageProductValueSummaries />

              {showProductComparisonSection === 'true' && !isSpecialOffer && (
                <PageProductComparison />
              )}

              {showProductValuePropositionsSection === 'true' && (
                <PageProductValuePropositions />
              )}

              {showProductPartnersSection === 'true' && <PageProductPartners />}

              <PageProductFooter />
            </div>
          </div>
        </ProductsContext.Provider>
      </Page>
    </Theme>
  );
};

PageMarketing.displayName = 'PageMarketing';

export default PageMarketing;
